import { MddHttpService } from 'app/core';
import { GetAccessToken } from '../oauth';
import { method } from 'lodash';

export class GetBlob {
    private mddHttpService: MddHttpService;
    private getAccessToken: GetAccessToken;

    constructor(mddHttp: MddHttpService) {
        this.getAccessToken = new GetAccessToken();
        this.mddHttpService = mddHttp;
    }

    execute(url: string): Promise<ArrayBuffer | undefined> {
        return this.mddHttpService
            .request<void, ArrayBuffer>(
                {
                    url: url,
                    headers: {
                        Authorization: `Bearer ${this.getAccessToken.execute()!.token}`
                    }
                },
                'blob'
            )
            .then((x) => x.body);
    }

    executePost(url: string, body: any): Promise<ArrayBuffer | undefined> {
        return this.mddHttpService
            .request<void, ArrayBuffer>(
                {
                    method: 'POST',
                    url: url,
                    body: body,
                    headers: {
                        Authorization: `Bearer ${this.getAccessToken.execute()!.token}`
                    }
                },
                'blob'
            )
            .then((x) => x.body);
    }
}
